module.exports = __webpack_public_path__ + "media/images/Heart_Navy_2x-1970e7c8.png";